import React from "react";
import {
  MenuItem,
  Select,
  Typography,
  FormControl,
  FormHelperText,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Controller } from "react-hook-form";
import BaseInput from "components/shared/baseForm/BaseInput";
import { REQUIRED_ERROR } from "utils/errorMessages";
import SearchIcon from "@mui/icons-material/Search";

export default function GuestOrder({
  control,
  errors,
  guestBillingTypeId,
  chargesByType,
  residents,
}) {
  return (
    <>
      <Grid
        container
        spacing={2}
        justifyContent="center"
        alignItems="flex-start"
        sx={{
          marginBottom: "20px",
        }}>
        <Grid size={5}>
          <BaseInput
            id="guestName"
            control={control}
            errors={errors}
            name="guestName"
            type="text"
            placeholder="Enter Guest Name"
            validationProps={{
              required: REQUIRED_ERROR("Name"),
              maxLength: {
                value: 50,
                message: "Guest Name cannot be over 50 characters",
              },
            }}
            fullWidth
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
              },
            }}
          />
        </Grid>
        <Grid size={5}>
          <Controller
            name="selectedResident"
            control={control}
            defaultValue={0}
            rules={{
              required: "Please select a resident",
              validate: (value) => value !== 0 || "Please select a resident",
            }}
            render={({ field, fieldState: { error } }) => (
              <FormControl fullWidth error={!!error}>
                <Select
                  {...field}
                  id="selectedResident"
                  variant="outlined"
                  fullWidth
                  displayEmpty
                  error={!!error}
                  startAdornment={
                    <SearchIcon
                      sx={{
                        color: "gray !important",
                        fontSize: "24px !important",
                      }}
                    />
                  }
                  sx={{
                    borderRadius: "8px",
                    "& .MuiSelect-select": {
                      paddingLeft: "4px",
                    },
                  }}>
                  <MenuItem value={0} disabled>
                    Guest Of
                  </MenuItem>
                  {residents?.map((res) => (
                    <MenuItem key={res.id} value={res.id}>
                      {res.name?.split("(")?.[0]?.trim()}
                    </MenuItem>
                  ))}
                </Select>
                {error && <FormHelperText>{error.message}</FormHelperText>}
              </FormControl>
            )}
          />
        </Grid>
      </Grid>

      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="center"
        sx={{ marginBottom: "20px" }}>
        <Grid size={3}>
          <Typography sx={{ textAlign: "right", fontWeight: "500" }}>
            Guest Charge:
          </Typography>
        </Grid>
        <Grid size={3}>
          <Controller
            name="guestBillingTypeId"
            control={control}
            defaultValue={guestBillingTypeId ?? 0}
            rules={{
              required: REQUIRED_ERROR("Guest Charge"),
              validate: (value) => value !== 0 || REQUIRED_ERROR("Charge Type"),
            }}
            render={({ field, fieldState: { error } }) => (
              <FormControl fullWidth error={!!error}>
                <Select
                  {...field}
                  value={field.value ?? 0}
                  onChange={(e) => field.onChange(Number(e.target.value))}
                  id="guestBillingTypeId"
                  variant="outlined"
                  size="small"
                  fullWidth
                  displayEmpty
                  sx={{
                    borderRadius: "8px",
                  }}
                >
                  <MenuItem value={0} disabled>
                    Select Charge
                  </MenuItem>
                  {chargesByType?.map((charge) => {
                    return (
                      <MenuItem key={charge.id} value={charge.id}>
                        {charge.chargeText}
                      </MenuItem>
                    );
                  })}
                </Select>
                {error && <FormHelperText>{error.message}</FormHelperText>}
              </FormControl>
            )}
          />
        </Grid>
      </Grid>
    </>
  );
}
